import Vue from 'vue'
import {
    Message, MessageBox, Button, Image, Form,
    FormItem, Input, Link,
    Loading,
    Breadcrumb,
    BreadcrumbItem,
    Dialog,
    Pagination,
    Radio,
    RadioGroup,
    Select,
    Option,
    OptionGroup,
    Upload,
    Checkbox,
    CheckboxButton,
    CheckboxGroup,
    Empty,
    DatePicker,
    TimeSelect,
    TimePicker,
    Calendar,
    Descriptions,
    DescriptionsItem,
    Tag,
    Row,
    Col,
    Tabs,
    TabPane,
    Table,
    TableColumn,
    Badge,
    Cascader,
    InputNumber,
    Rate,
    Dropdown,
    DropdownMenu,
    DropdownItem
} from 'element-ui'

// 引入组件
Vue.use(Button)
Vue.use(Image)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Link)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Dialog)
Vue.use(Loading)
Vue.use(Pagination);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Upload);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Empty);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(TimePicker);
Vue.use(Calendar);
Vue.use(Descriptions);
Vue.use(DescriptionsItem);
Vue.use(Tag);
Vue.use(Row);
Vue.use(Col);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Badge);
Vue.use(Cascader);
Vue.use(InputNumber);
Vue.use(Rate);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);

// 将Mesage挂载到vue原型对象上
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;